import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  SideNavigation as BaseSideNavigation,
  SideNavigationV2 as BaseSideNavigationV2,
} from 'portal-commons';
import { S3_ASSETS_PATH, RCS_CAMPAIGN_ENABLED } from '../../constants';
import { isMobile } from 'react-device-detect';
import { globalGetService } from '../../utils/globalApiServices';
import datadog from '../../utils/datadog';
import {
  faHome,
  faBullhorn,
  faTags,
  faCalendarDay,
  faMessageCaptions,
  faGearCode,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faHouse,
  faTags as faTagsSolid,
  faMessageCaptions as faMessageCaptionsSolid,
  faCalendarDay as faCalendarDaySolid,
  faGearCode as faGearCodeSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { useAuthContext } from '@/contexts';
import { SIDE_NAV_ENTRIES } from '@/constants/paths';
import { useRcsVisibility } from '@/hooks';

const getSideNavItems = ({ rcsVisible = false }) => [
  {
    title: 'Dashboard',
    icon: faHome,
    pathname: SIDE_NAV_ENTRIES.DASHBOARD,
    activeIcon: faHouse,
    'data-testid': 'sideNavigationDashboardButton',
  },
  RCS_CAMPAIGN_ENABLED
    ? {
        title: 'Campaigns',
        icon: faBullhorn,
        submenu: [
          {
            title: '10DLC',
            pathname: SIDE_NAV_ENTRIES.TEN_DLC_CAMPAIGNS,
            'data-testid': 'sideNavigationCampaignsButton',
          },
          ...(rcsVisible
            ? [
                {
                  title: 'RCS',
                  pathname: SIDE_NAV_ENTRIES.RCS_CAMPAIGNS,
                  'data-testid': 'sideNavigationRcsCampaignsButton',
                },
              ]
            : []),
        ],
      }
    : {
        title: 'Campaigns',
        icon: faBullhorn,
        pathname: SIDE_NAV_ENTRIES.TEN_DLC_CAMPAIGNS,
        'data-testid': 'sideNavigationCampaignsButton',
      },

  {
    title: 'Brands',
    icon: faTags,
    pathname: SIDE_NAV_ENTRIES.BRANDS,
    activeIcon: faTagsSolid,
    'data-testid': 'sideNavigationBrandButton',
  },
  {
    title: 'CSPs',
    icon: faMessageCaptions,
    pathname: SIDE_NAV_ENTRIES.CSP,
    activeIcon: faMessageCaptionsSolid,
    'data-testid': 'sideNavigationCspButton',
  },
  {
    title: 'Events',
    icon: faCalendarDay,
    pathname: SIDE_NAV_ENTRIES.EVENTS,
    activeIcon: faCalendarDaySolid,
    'data-testid': 'sideNavigationEventsButton',
  },
  {
    title: 'Integrations',
    icon: faGearCode,
    pathname: SIDE_NAV_ENTRIES.INTEGRATIONS,
    activeIcon: faGearCodeSolid,
    'data-testid': 'sideNavigationIntegrationsButton',
  },
];

export default function SideNavigation(props) {
  const { path } = props;
  const [lastLogin, setLastLogin] = useState('');
  const { profile } = useAuthContext();
  const rcsVisible = useRcsVisibility();

  useEffect(() => {
    if (localStorage.getItem('user') && !lastLogin) {
      const lastLoginTime = JSON.parse(localStorage.getItem('user')).lastLogin;
      setLastLogin(lastLoginTime);
    }
    if (!localStorage.getItem('user') && !lastLogin) {
      globalGetService('user').then((response) => {
        const user = response.data;
        !datadog.hasUser() && datadog.setUser(user);
        localStorage.setItem('user', JSON.stringify(user));
        setLastLogin(response.data ? response.data.lastLogin : '');
      });
    }
  }, []);

  const sideNavEntries = useMemo(() => {
    return getSideNavItems({ rcsVisible });
  }, [rcsVisible]);

  const Nav = useMemo(() => {
    if (profile?.market === 'DE' || profile?.market === 'HU') {
      return null;
    }
    if (RCS_CAMPAIGN_ENABLED) {
      return BaseSideNavigationV2;
    }
    return BaseSideNavigation;
  }, [profile?.market, RCS_CAMPAIGN_ENABLED]);

  return (
    <>
      <div
        data-testid="sideNavigationUserButton"
        className="primary-side-menu"
        style={
          path.includes('/user') ? (isMobile ? {} : { display: 'none' }) : {}
        }
      >
        {isMobile ? (
          <div className="header-logo">
            <Link to="/">
              <img
                src={`${S3_ASSETS_PATH}/images/Campaignregistry.svg`}
                alt="logo"
              />
            </Link>
          </div>
        ) : null}
        {Nav && (
          <Nav
            linkComponent={Link}
            portal="mno"
            location={{ pathname: path }}
            items={!path.includes('/user') ? sideNavEntries : []}
            lastLoginTime={lastLogin}
          />
        )}
      </div>
      {/* <div className="sidebar-gradient"></div> */}
    </>
  );
}
